import moment from 'moment';

export const buildQueryParams = (query) => {
    const result = {
    };
    const integrationId = query.get('integrationId');
    if (integrationId) {
        if (integrationId.toLowerCase() === 'commerceship') {
            result.cs = true;
        } else {
            result.cs = false;
            result.integrationId = integrationId;
        }
    }
    if (query.has('shipStartDate')) {
        result.shipStartDate = moment(query.get('shipStartDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('shipEndDate')) {
        result.shipEndDate = moment(query.get('shipEndDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('domestic')) {
        if (query.get('domestic') !== 'all') {
            result.domestic = query.get('domestic') === 'domestic';
        }
    }
    if (query.has('ground')) {
        if (query.get('ground') !== 'all') {
            result.ground = query.get('ground') === 'ground';
        }
    }
    if (query.has('service_levels')) {
        result.serviceLevelGroups = query.getAll('service_levels');
    }
    if (query.has('timeframe')) {
        result.timeframe = query.get('timeframe');
    }
    if (query.has('warehouse_id')) {
        result.warehouseIds = query.getAll('warehouse_id');
    }
    if (query.has('carriers')) {
        result.carriers = query.getAll('carriers');
    }
    return result;
};
